export default __webpack_public_path__ + "static/media/Armguards of Fearless Souls.da0a2be3.jpg";